/* @flow */
import cx from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';

import Heading from 'components/Heading';

export class TopicsSectionTitle extends React.Component<$FlowFixMeProps> {
  static propTypes = {
    children: PropTypes.node.isRequired,
  };

  render() {
    const { className, children } = this.props;

    return (
      <Heading level="3" className={cx('TopicsSectionTitle', className)}>
        {children}
      </Heading>
    );
  }
}

export default TopicsSectionTitle;
